/**
 * @generated SignedSource<<92d2efcadba886b96700f180de33e072>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithHeading_shoppingWith$data = {
  readonly title: string | null;
  readonly " $fragmentType": "ShoppingWithHeading_shoppingWith";
};
export type ShoppingWithHeading_shoppingWith$key = {
  readonly " $data"?: ShoppingWithHeading_shoppingWith$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShoppingWithHeading_shoppingWith">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShoppingWithHeading_shoppingWith",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "ShoppingWith",
  "abstractKey": null
};

(node as any).hash = "1b23e460addbfdc100cfdf648f8f60fc";

export default node;
